import { FormControl, ValidatorFn } from "@angular/forms";

export const convertToMaxValue = (maxValue: number): ValidatorFn => {
  return (control: FormControl) => {
    if(!control.value)
      return null;

      if(control.value>maxValue){
        control.patchValue(maxValue, { onlySelf:true });
        control.updateValueAndValidity();
      }


    return null;
  }
};
